import {Pagination} from '../pagination.model';
import {WorkerLite} from '../../../../workers-lite/shared/model/worker-lite.model';

export class WorkerLitePage extends Pagination {
  content: WorkerLite[] = [];
}
